/* istanbul ignore file */

export enum Routes {
  HOME = "/",
  LOGIN = "/login",
  LOGOUT = "/logout",
  RECOVERY = "/recovery",
  RESET = "/reset",
  WELCOME = "/welcome",
  FEED = "/feed",
  EDGES = "/edges",
  EDGES_EDGE = "/edges/:edgeId",
  ANALYTICS = "/analytics",
  ANALYTICS_INTEGRATIONS = "/analytics/integrations",
  ARTICLES = "/articles",
  ARTICLES_KNOWLEDGE_GAPS = "/articles/knowledge-gaps",
  ARTICLES_COVERED_GAPS = "/articles/covered-gaps",
  ARTICLES_ARCHIVED_GAPS = "/articles/archived-gaps",
  ARTICLES_KNOWLEDGE_GAP_CONFIG = "/articles/knowledge-gap-config",
  ARTICLES_DRAFTS = "/articles/drafts",
  ARTICLES_REQUESTS = "/articles/requests",
  ARTICLES_ALL = "/articles/all",
  ARTICLES_PENDING = "/articles/pending",
  ARTICLES_REVIEW = "/articles/review",
  ARTICLE = "/article/:articleId",
  SETTINGS = "/settings",
  SETTINGS_INTEGRATIONS = "/settings/integrations",
  SETTINGS_INTEGRATIONS_CONNECTIONS = "/settings/integrations/connections",
  SETTINGS_INTEGRATIONS_CUSTOMER_DATA = "/settings/integrations/customer-data",
  SETTINGS_INTEGRATIONS_TICKETS = "/settings/integrations/tickets",
  SETTINGS_INTEGRATIONS_ISSUES = "/settings/integrations/issues",
  SETTINGS_INTEGRATIONS_SOCIAL = "/settings/integrations/social",
  SETTINGS_INTEGRATIONS_KNOWLEDGE = "/settings/integrations/knowledge",
  SETTINGS_INTEGRATIONS_AUTH = "/settings/integrations/authentication",
  SETTINGS_INTEGRATIONS_FEDERATED_SEARCH = "/settings/integrations/federated-search",
  SETTINGS_INTEGRATIONS_SOURCE_DISPLAY_NAMES = "/settings/integrations/source-display-names",
  SETTINGS_APPS = "/settings/apps",
  SETTINGS_APPS_SUPPORT = "/settings/apps/support",
  SETTINGS_APPS_SELF_SERVICE = "/settings/apps/self-service",
  SETTINGS_APPS_SLACK = "/settings/apps/slack",
  SETTINGS_MACHINE_LEARNING = "/settings/machine-learning",
  SETTINGS_MACHINE_LEARNING_AGENT_EMAIL = "/settings/machine-learning/agent-email",
  SETTINGS_MACHINE_LEARNING_LABELS = "/settings/machine-learning/labels",
  SETTINGS_MACHINE_LEARNING_SEARCH_TERMS = "/settings/machine-learning/search-terms",
  SETTINGS_WORKFLOW = "/settings/workflow",
  SETTINGS_WORKFLOW_TEAMS = "/settings/workflow/teams",
  SETTINGS_WORKFLOW_TEMPLATES = "/settings/workflow/templates",
  SETTINGS_FILTERS = "/settings/filters",
  SETTINGS_DATA = "/settings/data",
  SETTINGS_DATA_TICKETS = "/settings/data/tickets",
  SETTINGS_DATA_ISSUES = "/settings/data/issues",
  SETTINGS_DATA_ARTICLES = "/settings/data/articles",
  SETTINGS_DATA_SOCIAL = "/settings/data/social",
  SETTINGS_DATA_DOCUMENTS = "/settings/data/documents",
  SETTINGS_DATA_EDGES = "/settings/data/edges",
  SETTINGS_DATA_GENERATED_KNOWLEDGE = "/settings/data/generated-knowledge",
  SETTINGS_AI_TOOLS = "/settings/ai-tools",
  SETTINGS_ANSWERAI_TUNING = "/settings/answerai-tuning",
  SETTINGS_FILTERS_HIDDEN = "/settings/filters/hidden",
  SETTINGS_FILTERS_PRODUCT = "/settings/filters/product",
  SETTINGS_FILTERS_QUICK = "/settings/filters/quick",
  SETTINGS_FILTERS_KEYWORD_LISTS = "/settings/filters/keyword-lists",
  SETTINGS_MY_PRODUCTS = "/settings/my-products",
  SETTINGS_RUNBOOKS = "/settings/runbooks",
  SETTINGS_RUNBOOKS_AFR = "/settings/runbooks/afr",
  SETTINGS_RUNBOOKS_CSS = "/settings/runbooks/css",
  SETTINGS_RUNBOOKS_KC = "/settings/runbooks/kc",
  SETTINGS_RUNBOOKS_TI = "/settings/runbooks/ti",
  SETTINGS_RUNBOOKS_SLACK = "/settings/runbooks/slack",
  SETTINGS_RUNBOOKS_REPLY = "/settings/runbooks/reply",
  SETTINGS_TICKET_FIELDS = "/settings/filters/ticket-fields",
  USER_SETTINGS = "/user-settings",
  TICKETS = "/tickets",
  TICKET = "/tickets/:ticketId",
  CONVERSATIONS = "/conversations",
  AI_AGENTS = "/ai-agents",
  AI_AGENTS_RUNS = "/ai-agents/runs",
  AI_AGENTS_DASHBOARD = "/ai-agents/dashboard",
  AI_AGENTS_CONFIGURATION = "/ai-agents/configuration",
  AI_AGENTS_NEW = "/ai-agents/new",
  AI_AGENTS_AGENT = "/ai-agents/:agentId",
  GLOBAL_SEARCH = "/search",
  GLOBAL_OAUTH = "/global-oauth/:provider",
  ADMIN_DASHBOARD = "/settings/admin-dashboard",
  CSS_CONFIG = "/settings/css-config",
  CSS_CONFIG_KNOWLEDGE_SOURCES = "/settings/css-config/knowledge-sources",
  CSS_CONFIG_GENERAL = "/settings/css-config/general",
  CSS_CONFIG_RESOURCES = "/settings/css-config/resources",
  CSS_CONFIG_LIMITS = "/settings/css-config/limits",
  CSS_CONFIG_INTERNAL = "/settings/css-config/internal-config",
  CSS_CONFIG_INTEGRATION = "/settings/css-config/integration",
  SETTINGS_TENANT_MANAGEMENT = "/settings/tenant-management",
  SETTINGS_PRIVACY = "/settings/privacy",
  DOCUMENT_FILES = "/edges/:sourcetype/files/:fileId"
}
